var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "22px",
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5BF46405-0E02-4355-B38C-429CD53CA5C8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting",
    transform: "translate(-1234.000000, -49.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1234.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8124823,10.4229217 L19.1387234,0.581694915 C18.9360247,0.230100364 18.5614258,0.0134947538 18.1560284,0.0134947538 L6.80851064,0.0134947538 C6.40311318,0.0134947538 6.02851433,0.230100364 5.8258156,0.581694915 L0.152056738,10.4229217 C-0.0506471432,10.7745252 -0.0506471432,11.2077186 0.152056738,11.559322 L5.8258156,21.4005488 C6.02851433,21.7521434 6.40311318,21.968749 6.80851064,21.968749 L18.1560284,21.968749 C18.5614258,21.968749 18.9360247,21.7521434 19.1387234,21.4005488 L24.8124823,11.559322 C25.0151862,11.2077186 25.0151862,10.7745252 24.8124823,10.4229217 Z M17.5012766,19.6959483 L7.46326241,19.6959483 L2.44425532,10.9911219 L7.46326241,2.2862954 L17.5012766,2.2862954 L22.5202837,10.9911219 L17.5012766,19.6959483 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4822695,6.44552058 C9.97544511,6.44552058 7.94326241,8.4806556 7.94326241,10.9911219 C7.94326241,13.5015881 9.97544511,15.5367232 12.4822695,15.5367232 C14.9890939,15.5367232 17.0212766,13.5015881 17.0212766,10.9911219 C17.0212766,8.4806556 14.9890939,6.44552058 12.4822695,6.44552058 L12.4822695,6.44552058 Z M12.4822695,13.2639225 C11.2288573,13.2639225 10.212766,12.246355 10.212766,10.9911219 C10.212766,9.73588874 11.2288573,8.71832123 12.4822695,8.71832123 C13.7356817,8.71832123 14.751773,9.73588874 14.751773,10.9911219 C14.751773,12.246355 13.7356817,13.2639225 12.4822695,13.2639225 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settingsIcon.a0f16f443d85a9fa06f48b5a1606be5f.svg";